export default {
  init() {
    // JavaScript to be fired on all pages
    $(document).ready(function(){

      $('.hamburger').on('click', function() {
        $(this).toggleClass('is-active');
        // Do something else, like open/close menu
      });

      /* Ajax /partials/ajax-news.php */
      function ajax_news(param_order) {
        var $place = $('#contect-news-placement');
        // eslint-disable-next-line no-undef
        var $url = obj_var.ajax_news;
        var val_order_by = param_order;
        var val_order = 'asc', val_count;

        if($('body').hasClass('home')) {
          val_count = 6;
        } else if ($('body').hasClass('template-employer')){
          val_count = 3;
        }

        $.ajax({
            type       : 'GET',
            data       : {order_by : val_order_by, order : val_order, count : val_count},
            dataType   : 'html',
            url        : $url,
            beforeSend : function(){

            },
            success    : function(data){
                $place.html(data);
            },
            error     : function(jqXHR, textStatus, errorThrown) {
                alert(jqXHR + ' :: ' + textStatus + ' :: ' + errorThrown);
            },
        });
      }

      /* ajax news for the first time */
      if($('.section-that-new').hasClass('section-that-new')) {
        ajax_news('date');
      }

      /* Filter selector - bootstrap*/
      if(!$('.section-posts-pagination').hasClass('section-posts-pagination')) {
        $('.filter .filter-news a').click(function(e){
          e.preventDefault();
          var selected = $(this).attr('data-value');
          var textSelected = $(this).text();

          ajax_news(selected);
          $(this).parent().siblings('.btn').text(textSelected);
        });
      }

      /* Lazy load images background*/
      function lazyloadimgbg() {
          var images_src;

          $.each($('.lazy-load-bg-img'), function() {
            if($('lazy-load-bg-img').hasClass('finished') == false){
              images_src = $(this).attr('data-lazy-src');
              // console.log($('lazy-load-bg-img').hasClass('finished'));
              $(this).css({
                'background-image': 'url('+images_src+')',
              })
              $('.lazy-load-bg-img').addClass('finished');
            }
          });
      }

      /* Call lazy load images background */
      $(window).scroll(function(){
        lazyloadimgbg();
      });

      /* Adding class to IE and Edge */
      function CheckIE() {
        // Internet Explorer 6-11
        var isIE = /*@cc_on!@*/false || !!document.documentMode;
        // Edge 20+
        var isEdge = !isIE && !!window.StyleMedia;

        var browserName;

        if(isIE) {
                browserName = 'iexplorer'
                $('header').addClass(browserName);
                $('.main').addClass(browserName);
        }else if(isEdge) {
                browserName = 'edge'
                $('header').addClass(browserName);
                $('.main').addClass(browserName);
        }
      }
      CheckIE();


      /* disable
      function externalLinks() {
        for(var c = document.getElementsByTagName('a'), a = 0;a < c.length;a++) {
          var b = c[a];
          b.getAttribute('href') && b.hostname !== location.hostname && (b.target = '_blank')
        }
      }

      externalLinks();
      */

      /* Function for change tab section */
      $('.section-tabs .outer-tab-name .wrapper').click(function(){
        $('.outer-tab-name .wrapper').removeClass('active');
        $('.outer-content .inner-wrapper').removeClass('active');
        $('.outer-content .inner-wrapper.'+datatab).removeClass('fadeshow');

        $(this).addClass('active');
        var datatab = $(this).attr('data-tab');
        $('.outer-content .inner-wrapper.'+datatab).addClass('active');
        $('.outer-content .inner-wrapper.'+datatab).addClass('fadeshow');
      });

      $('.section-tabs.howitworks .tab-works').click(function() {
          // console.log('tabworks');
          var targetClass = $(this).attr('data-targetclass');
          // console.log('.section-howitworks.' + targetClass);
          $('.section-howitworks').removeClass('d-block');
          $('.section-howitworks').addClass('d-none');
          $('.section-howitworks.' + targetClass).addClass('d-block');
      });

      /* Function fire event after/before accordion open/close - bootstrap */
      function accordionEvent() {
        var accordionItem = $('#sectionTabMobile .card-header');
        var accordionItemlength = accordionItem.length;
        for( var i = 0 ; i < accordionItemlength; i++) {
          $('#collapse' + i).on('show.bs.collapse', function () {
            $('.card-header').removeClass('active');
            $(this).siblings('.card-header').addClass('active');
          })

          $('#collapse' + i).on('hiden.bs.collapse', function () {
            $(this).siblings('.card-header').removeClass('active');
          })
        }
      }
      accordionEvent();

      function accordionFAQ() {
        var accordionItem = $('#accordion-faq .card-header');
        var accordionItemlength = accordionItem.length;
        for( var i = 0 ; i < accordionItemlength; i++) {
          $('#collapse' + i).on('show.bs.collapse', function () {
            $('.card-header').removeClass('active');
            $(this).siblings('.card-header').addClass('active');
          })

          $('#collapse' + i).on('hide.bs.collapse', function () {
            $(this).siblings('.card-header').removeClass('active');
          })
        }
      }
      accordionFAQ();

      /* slick carousel setting & initialiaztion*/
      $('.slick-carousel').slick({
        autoplay: true,
        infinite: true,
        speed: 2000,
        autoplaySpeed: 2000,
        slidesToShow: 3,
        slidesToScroll: 3,
        swipeToSlide: true,
        centerMode: true,
        variableWidth: true,
        arrows: true,
      });

      $('.carousel-slick').slick({
        autoplay: true,
        infinite: true,
        speed: 2000,
        autoplaySpeed: 2000,
        slidesToShow: 1,
        slidesToScroll: 1,
      });

      /* event hover page how-it-works */
      $(document).ready(function(){
        $('div#learning-work div.wrapper').hover(
          function () { // mouse masuk
            $('div#learning-work div.wrapper.active').css('background-color', 'transparent');
            $(this).css('background-color', '#3e5a62');
          },
          function () { // mouse keluar
            $('div#learning-work div.wrapper.active').css('background-color', '#3e5a62');
            $(this).css('background-color', 'transparent');
          }
        );
      });

      /* new tab external link */
      function externalLinks() {
        for(var c = document.getElementsByTagName('a'), a = 0;a < c.length;a++) {
          var b = c[a];
          b.getAttribute('href') && b.hostname !== location.hostname && (b.target = '_blank')
        }
      }
      externalLinks();

      /* get all list image */
      function get_all_image_path() {
        var all_images1 = $('.lazy-load-bg-img');
        var all_images2 = $('.bg-image');
        var all_images3 = $('img');
        var array_images = [];
        all_images1.each(function(){
          array_images.push($(this).attr('data-lazy-src'));
        });
        all_images2.each(function(){
          array_images.push($(this).css('background-image'));
        });
        all_images3.each(function(){
          array_images.push($(this).attr('src'));
        });
        //get unique value from array
        //var unique = array_images.filter((val, idx, self) => self.indexOf(val) === idx);
       // console.log(unique);
      }
      get_all_image_path();

      var idx_loop_image = 0;
      $(window).scroll(function(){
          if(idx_loop_image < 1) {
            get_all_image_path();
          }
          idx_loop_image++;
      });

      /** load gform*/
      $('.load-pop-gform').on('click', function (e) {
        e.preventDefault();
        var idgform = $(this).attr('data-idform');
        var modal_title = $(this).attr('data-title');
        var modal_sub_title = $(this).attr('data-description');
        // eslint-disable-next-line no-undef
        var $url = obj_var.admin_ajax;
        $.get( $url + '?action=gf_button_get_form&form_id=' + idgform, function(response){
          $('#form_placeholder').html(response).fadeIn();
          $('.modal-title span').html(modal_title).fadeIn();
          $('.modal-sub-title').html(modal_sub_title).fadeIn();
        });
      });

      $('#generalModal').on('hide.bs.modal', function () {
        $('#form_placeholder').html('');
     });

    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js